import React from "react";

function CreateCategory({
  editingCategory,
  handleSubmit,
  handleCancel,
  isCreatingCategory,
  isUpdatingCategory,
  onSetName,
  name,
}) {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-6">
        {editingCategory ? "Edit Category" : "Create New Category"}
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Category Name *
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => onSetName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter category name"
            required
          />
        </div>

        <div className="flex space-x-4">
          <button
            type="submit"
            disabled={isCreatingCategory || isUpdatingCategory}
            className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isCreatingCategory || isUpdatingCategory
              ? "Saving..."
              : editingCategory
              ? "Update Category"
              : "Create Category"}
          </button>
          <button
            type="button"
            onClick={handleCancel}
            className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md hover:bg-gray-400 transition-colors"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateCategory;
